import { DropOffView } from "@/libs/tours-detail/views/DropOffView";
import { useParams } from "react-router";

export function DropOffStopPage() {
  const { id, stopId } = useParams<{ id: string; stopId: string }>();

  if (!id || !stopId) {
    return null;
  }

  return <DropOffView tourId={id} stopId={stopId} />;
}
